module.exports = __webpack_public_path__ + "img/resume.ecf960cc.jpg";